import { memo } from 'react'
import * as Styled from './styled'
import { IProps } from './types'
import ArrowDownFilledIcon from 'assets/svgr-icons/Arrow_Down_Filled.svg'
const ListItem = ({
  data: {
    icon: IconComp,
    iconBgColor,
    label,
    url,
    onClick,
    className,
    isExpandable,
    isExpanded
  }
}: IProps) => {
  const content = (
    <>
      <Styled.IconWrapper $iconBgColor={iconBgColor}>
        <IconComp />
      </Styled.IconWrapper>
      <Styled.Label>{label}</Styled.Label>
    </>
  )

  return (
    <Styled.ListItemWrapper onClick={onClick} className={className}>
      {url ? (
        <Styled.ListItemLink href={url}>{content}</Styled.ListItemLink>
      ) : (
        <Styled.ListItem>{content}</Styled.ListItem>
      )}
      {isExpandable && (
        <Styled.ArrowDownWrapper $isExpanded={!!isExpanded}>
          <ArrowDownFilledIcon />
        </Styled.ArrowDownWrapper>
      )}
    </Styled.ListItemWrapper>
  )
}

export default memo(ListItem)
